// extracted by mini-css-extract-plugin
export default {"melodyVideo":"sI-z","isFullWidth":"tI-z","landingPageVideo":"uI-z","play":"vI-z","iframeVideo":"wI-z","playHidden":"xI-z","fullwidth":"yI-z"};